module.exports = __webpack_public_path__ + "img/1472951721.fb362c1d.jpg";